import script from "./Excel.vue?vue&type=script&setup=true&lang=js"
export * from "./Excel.vue?vue&type=script&setup=true&lang=js"

import "./Excel.vue?vue&type=style&index=0&id=09ee99d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ee99d6"]])

export default __exports__